import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { CartDrawer } from "./CartDrawer";
import { CardGateMount } from "./CardGateMount";
import { ChatWidget } from "./ChatWidget";
import { CartProvider } from "../context/CartContext";

/**
 * Shared shell for static/content pages (Manifesto, FAQ, Spedizioni, ...).
 * Applies the site chrome (Navbar + Footer + Cart + Chat) and renders a
 * consistent hero + breadcrumb so every page looks like it belongs to the site.
 */
export const SitePage = ({
  eyebrow,
  title,
  accent,
  subtitle,
  breadcrumb, // e.g. "Brand"
  breadcrumbLabel, // last segment shown in the breadcrumb (defaults to `title`)
  testId,
  children,
  wide = false,
}) => (
  <CartProvider>
    <div className="App bg-zinc-950 min-h-screen text-white">
      <Navbar />

      <main className="pt-24" data-testid={testId}>
        {/* Hero */}
        <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 border-b-2 border-zinc-900">
          <nav data-testid="site-breadcrumb" className="text-xs uppercase tracking-widest text-zinc-500 mb-4 flex items-center gap-1.5 font-heading">
            <Link to="/" data-testid="breadcrumb-home" className="hover:text-yellow-400 transition">Home</Link>
            {breadcrumb && (
              <>
                <ChevronRight className="w-3 h-3 opacity-60" />
                <span>{breadcrumb}</span>
              </>
            )}
            <ChevronRight className="w-3 h-3 opacity-60" />
            <span className="text-yellow-400">{breadcrumbLabel || title}</span>
          </nav>
          {eyebrow && (
            <div className="font-jp text-yellow-400 text-sm tracking-widest mb-3">{eyebrow}</div>
          )}
          <h1 className="font-heading text-5xl sm:text-6xl lg:text-7xl uppercase text-white leading-none">
            {title} {accent && <span className="text-yellow-400">{accent}</span>}
          </h1>
          {subtitle && (
            <p className="text-zinc-400 mt-5 max-w-2xl text-base sm:text-lg leading-relaxed">{subtitle}</p>
          )}
        </section>

        {/* Body */}
        <section className={`${wide ? "max-w-7xl" : "max-w-4xl"} mx-auto px-4 sm:px-6 lg:px-8 py-16`}>
          {children}
        </section>
      </main>

      <Footer />
      <CartDrawer />
      <CardGateMount />
      <ChatWidget />
    </div>
  </CartProvider>
);

export default SitePage;
